import { registerNestedOrbParser, } from '../NestedOrbExpansionRegistry';
function normalizeLabel(value, fallback) {
    if (!value)
        return fallback;
    const trimmed = value.replace(/\s+/g, ' ').trim();
    const maxLength = 15;
    if (trimmed.length <= maxLength)
        return trimmed;
    return `${trimmed.slice(0, maxLength - 1)}…`;
}
const PARENT_TAG_PREFIX = 'desmos:parent:';
const FOLDER_TAG_PREFIX = 'desmos:folder:';
const IN_FOLDER_PREFIX = 'desmos:in-folder:';
const PARENT_EDGE_PROFILE = {
    style: { color: 0x26a69a, widthPx: 2.5 },
    arrows: { end: true, start: false, size: 6 },
    elastic: {
        enabled: true,
        rest: 540,
        stiffness: 5.5,
        damping: 2.4,
        transverseDamping: 1.8,
        maxForce: 210,
        minSeparation: 24,
        maxDistance: 1400,
        impulseScale: 0.85,
        deadband: 6,
    },
};
const FOLDER_PARENT_PROFILE = {
    style: { color: 0x5e35b1, widthPx: 3.5 },
    arrows: { end: true, start: false, size: 7 },
    elastic: {
        enabled: true,
        rest: 520,
        stiffness: 5,
        damping: 2.2,
        transverseDamping: 1.6,
        maxForce: 180,
        minSeparation: 24,
        maxDistance: 1200,
        impulseScale: 0.82,
    },
};
function buildFolderChildEdgeProfile() {
    return {
        style: { color: 0x7c4dff, widthPx: 3 },
        arrows: { end: true, start: false, size: 8 },
        elastic: {
            enabled: true,
            rest: 520,
            stiffness: 4.2,
            damping: 2.1,
            transverseDamping: 1.6,
            maxForce: 190,
            minSeparation: 24,
            maxDistance: 1200,
            impulseScale: 0.82,
        },
    };
}
registerNestedOrbParser('desmosExpressions', ({ orb }) => {
    var _a, _b, _c, _d, _e, _f;
    const raw = ((_a = orb.jsonData) !== null && _a !== void 0 ? _a : {});
    const expressions = Array.isArray(raw.expressions) ? raw.expressions : [];
    const parentId = typeof raw.id === 'string' ? raw.id : (_c = (_b = orb.jsonData) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : 'unknown';
    if (expressions.length === 0) {
        return { orbs: [] };
    }
    const baseTag = `${PARENT_TAG_PREFIX}${parentId}`;
    const generated = [];
    const folders = new Map();
    for (const expr of expressions) {
        const data = Object.assign(Object.assign({}, expr), { parentDesmosId: parentId });
        const type = (_d = expr.type) !== null && _d !== void 0 ? _d : 'expression';
        const folderId = typeof expr.folderId === 'string' ? expr.folderId : undefined;
        if (type === 'folder') {
            const folderTag = `${FOLDER_TAG_PREFIX}${(_e = expr.id) !== null && _e !== void 0 ? _e : cryptoRandomSuffix()}`;
            const label = normalizeLabel(expr.title, expr.id ? `Folder ${expr.id}` : 'Folder');
            generated.push({
                orbType: 'DESMOS_FOLDER',
                label,
                data,
                tags: [baseTag, folderTag, 'desmos:folder'],
                parentConnectionProfile: FOLDER_PARENT_PROFILE,
                connectionSteps: expr.id
                    ? [
                        {
                            from: { kind: 'self' },
                            to: { kind: 'tag', tag: `${IN_FOLDER_PREFIX}${expr.id}` },
                            edgeProfile: buildFolderChildEdgeProfile(),
                        },
                    ]
                    : undefined,
            });
            if (expr.id) {
                folders.set(expr.id, folderTag);
            }
            continue;
        }
        if (type === 'text') {
            const label = normalizeLabel(expr.text, expr.id ? `Text ${expr.id}` : 'Text');
            const tags = [baseTag, 'desmos:expression', 'desmos:text'];
            if (folderId) {
                tags.push(`${IN_FOLDER_PREFIX}${folderId}`);
            }
            generated.push({
                orbType: 'DESMOS_TEXT',
                label,
                data,
                tags,
                disableParentConnection: !!folderId,
                parentConnectionProfile: folderId ? undefined : PARENT_EDGE_PROFILE,
            });
            continue;
        }
        const latexLabel = normalizeLabel((_f = expr.latex) !== null && _f !== void 0 ? _f : expr.text, expr.id ? `Expression ${expr.id}` : 'Expression');
        const latexTags = [baseTag, 'desmos:expression', 'desmos:latex'];
        if (folderId) {
            latexTags.push(`${IN_FOLDER_PREFIX}${folderId}`);
        }
        generated.push({
            orbType: 'DESMOS_LATEX',
            label: latexLabel,
            data,
            tags: latexTags,
            disableParentConnection: !!folderId,
            parentConnectionProfile: folderId ? undefined : PARENT_EDGE_PROFILE,
        });
    }
    const connectionSteps = [];
    folders.forEach((tag, folderId) => {
        connectionSteps.push({
            from: { kind: 'tag', tag },
            to: { kind: 'tag', tag: `${IN_FOLDER_PREFIX}${folderId}` },
            edgeProfile: buildFolderChildEdgeProfile(),
        });
    });
    return { orbs: generated, connectionSteps };
});
function cryptoRandomSuffix() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID().slice(-6);
    }
    return Math.random().toString(36).slice(-6);
}
